import { create, StoreApi, UseBoundStore } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type WithSelectors<S> = S extends { getState: () => infer T } ? S & { use: { [K in keyof T]: () => T[K] } } : never;

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(_store: S) => {
  let store = _store as WithSelectors<typeof _store>;
  store.use = {};
  for (let k of Object.keys(store.getState())) {
    (store.use as any)[k] = () => store(s => s[k as keyof typeof s]);
  }

  return store;
};

export interface TFormValue {}

interface THelpFeedback {
  bannerList: GetBannerListResponse[];
  helpConfigList: GetHelpListResponse[];
}

const initialStoreValue = {
  bannerList: [],
  helpConfigList: [],
};

export const useHelpFeedbackStore = createSelectors(
  create(
    devtools<THelpFeedback>(() => initialStoreValue, {
      enabled: __BUILD_ENV__ !== 'prod',
    })
  )
);

export const setBannerList = (payload: THelpFeedback['bannerList']) =>
  useHelpFeedbackStore.setState(() => ({ bannerList: payload }));

export const setHelpConfigList = (payload: THelpFeedback['helpConfigList']) =>
  useHelpFeedbackStore.setState(() => ({ helpConfigList: payload }));
